/**
 * Stytch Invitation Hooks
 *
 * These hooks provide convenient wrappers for invitation operations
 * using the Stytch B2B client.
 */
import { getStytchClient } from './../client/headless-client';
/**
 * Hook to send an invitation via magic link email
 */
export function useSendInvitation() {
    const stytch = getStytchClient();
    return async (data) => {
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.magicLinks.email.invite({
                email_address: data.email_address,
                invite_redirect_url: data.invite_redirect_url,
                invite_template_id: data.invite_template_id,
                name: data.name,
                roles: data.roles,
                untrusted_metadata: data.untrusted_metadata,
                locale: data.locale,
            });
            return {
                success: true,
                invitation: result,
                data: result,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to send invitation',
                data: error,
            };
        }
    };
}
